import React, { useState, useEffect } from 'react';
import { API_URL, fetchData } from '../helpers/api';
import FormatDate from '../utils/dateTools';
import MagazineViewer from '../components/MagazineViewer';
import '../css/magazine.css';
import TruncatableHtmlContent from '../utils/TruncatableHtmlContent';

const MagazinePage = () => {
    const [magazines, setMagazines] = useState([]);
    const [selectedMagazine, setSelectedMagazine] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [viewerOpen, setViewerOpen] = useState(false);

    useEffect(() => {
        fetchMagazines();
    }, []);

    const fetchMagazines = async () => {
        try {
            setLoading(true);
            const fetchedMagazines = await fetchData('/api/magazines?populate=*');
            // console.log(fetchedMagazines);
            
            // Filter out unpublished magazines
            const publishedMagazines = fetchedMagazines.filter(magazine => magazine.isPublished);
            
            // Sort by publication date (newest first)
            const sortedMagazines = publishedMagazines.sort((a, b) => 
                new Date(b.publicationDate) - new Date(a.publicationDate)
            );
            
            setMagazines(sortedMagazines);
        } catch (error) {
            console.error('Failed to fetch magazines:', error);
        } finally {
            setLoading(false);
        }
    };

    const openMagazine = async (magazine) => {
        try {
            setSelectedMagazine(magazine);
            console.log(magazine)
            
            if (magazine.pdfFile) {
                const url = API_URL + magazine.pdfFile.url;
                setPdfUrl(url);
                setViewerOpen(true);
            }
        } catch (error) {
            console.error('Failed to open magazine:', error);
        }
    };

    const closeMagazineViewer = () => {
        setViewerOpen(false);
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-warning" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="magazine-page">
            {/* Hero Section */}
            <section className="bg-dark text-white py-5">
                <div className="container py-5 text-center">
                    <h1 className="display-4 fw-bold mb-4">
                        NOS <span className="text-warning">MAGAZINES</span>
                    </h1>
                    <p className="fs-5 mx-auto" style={{ maxWidth: '800px' }}>
                        Découvrez les éditions du magazine du Mémorial ACTe
                    </p>
                </div>
            </section>

            {/* Magazine List Section */}
            <section className="py-5 bg-white">
                <div className="container py-3">
                    {magazines.length === 0 ? (
                        <div className="text-center py-5">
                            <p className="fs-4 text-muted">Aucun magazine disponible pour le moment</p>
                        </div>
                    ) : (
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-5">
                            {magazines.map((magazine) => (
                                <div key={magazine.id} className="col">
                                    <div 
                                        className="card h-100 border-0 shadow magazine-card hover-translate-up transition"
                                        onClick={() => openMagazine(magazine)}
                                    >
                                        {magazine.coverImage && (
                                            <div className="card-img-container">
                                                <img 
                                                    src={API_URL + magazine.coverImage.url} 
                                                    alt={magazine.title} 
                                                    className="card-img-top magazine-cover"
                                                />
                                            </div>
                                        )}
                                        <div className="card-body d-flex flex-column p-4">
                                            <div className="d-flex align-items-center text-muted small mb-2">
                                                <FormatDate dateString={magazine.publicationDate} format="short" />
                                            </div>
                                            
                                            <h3 className="fs-5 fw-bold mb-3">{magazine.title}</h3>
                                            
                                            <div className="text-muted small mb-4 flex-grow-1">
                                                {magazine.description && (
                                                    <TruncatableHtmlContent
                                                        html={magazine.description}
                                                        truncate={true}
                                                        maxLength={120}
                                                    />
                                                )}
                                            </div>
                                            
                                            <button className="btn btn-warning rounded-pill mt-auto w-100">
                                                Lire le magazine
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* Magazine Viewer Modal */}
            {viewerOpen && pdfUrl && (
                <div className="magazine-modal">
                    <div className="magazine-modal-content">
                        <div className="magazine-modal-header">
                            <h2>{selectedMagazine?.title}</h2>
                            <button 
                                className="btn-close" 
                                onClick={closeMagazineViewer}
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="magazine-modal-body">
                            <MagazineViewer pdfUrl={pdfUrl} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MagazinePage;